/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import {
  INVOICE_CREDIT,
  INVOICE_ESTIMATION,
  INVOICE_LESSOR_FIRST_INVOICE,
  INVOICE_MANAGEMENT,
  INVOICE_OWNER,
  INVOICE_PROFORMA,
  INVOICE_RENT,
  INVOICE_SALE,
  INVOICE_TENANT,
  INVOICE_TENANT_FIRST_INVOICE
} from '../../enums/InvoiceTypes.mjs'
import { ComboboxItem } from '@mantine/core'

function useInvoiceTypeOptions (empty = false, types?: (InvoiceType | string)[]): ComboboxItem[] {
  const intl = useIntl()
  return useMemo(() => {
    const list: ComboboxItem[] = [
      {
        label: '',
        value: ''
      },
      {
        label: intl.formatMessage({
          id: 'estimation',
          defaultMessage: 'Estimation'
        }),
        value: INVOICE_ESTIMATION
      },
      {
        label: intl.formatMessage({
          id: 'rent',
          defaultMessage: 'Loyer'
        }),
        value: INVOICE_RENT
      },
      {
        label: intl.formatMessage({
          id: 'management',
          defaultMessage: 'Gestion'
        }),
        value: INVOICE_MANAGEMENT
      },
      {
        label: intl.formatMessage({
          id: 'lessor_first_invoice',
          defaultMessage: 'Première facture propriétaire'
        }),
        value: INVOICE_LESSOR_FIRST_INVOICE
      },
      {
        label: intl.formatMessage({
          id: 'owner_invoice',
          defaultMessage: 'Facture propriétaire'
        }),
        value: INVOICE_OWNER
      },
      {
        label: intl.formatMessage({
          id: 'tenant_invoice',
          defaultMessage: 'Facture locataire'
        }),
        value: INVOICE_TENANT
      },
      {
        label: intl.formatMessage({
          id: 'tenant_first_invoice',
          defaultMessage: 'Première facture locataire'
        }),
        value: INVOICE_TENANT_FIRST_INVOICE
      },
      {
        label: intl.formatMessage({
          id: 'sale_invoice',
          defaultMessage: 'Facture de vente'
        }),
        value: INVOICE_SALE
      },
      {
        label: intl.formatMessage({
          id: 'proforma_invoice',
          defaultMessage: 'Facture proforma'
        }),
        value: INVOICE_PROFORMA
      },
      {
        label: intl.formatMessage({
          id: 'credit_invoice',
          defaultMessage: 'Facture d\'avoir'
        }),
        value: INVOICE_CREDIT
      }
    ]
    return (
      types != null
        ? list.filter((el) => types.includes(el.value) || el.value === '')
        : list
    )
      .filter((el) => empty || el.value !== '')
      .sort((a, b) => a.label.localeCompare(b.label))
  }, [intl, types, empty])
}

export default useInvoiceTypeOptions
